import type { RouterProviderProps } from 'react-router';

import { createBrowserRouter } from 'react-router';

import AuthProvider from '~/plugins/auth/provider';
import infoRoute from '~/plugins/router/routes/info';

import type { RouterConfigOptions } from './_config.type';

import AppRouterContainer from './container';
import ErrorBoundary from './error-boundary';
import errorRoute from './routes/error';
import guestRoute from './routes/guest';
import unverifiedUserRoute from './routes/unverified-user';
import userRoute from './routes/user';

/**
 * Create Router config.
 *
 * @param {RouterConfigOptions} options Options.RouterProvider.
 *
 * @returns {RouterProviderProps} Router config.
 */
export default function createRouterConfig({ hydrateFallback }: RouterConfigOptions): RouterProviderProps {
  return {
    router: createBrowserRouter([
      {
        ErrorBoundary,
        Component: AppRouterContainer,

        children: [
          {
            Component: AuthProvider,
            children: [guestRoute, unverifiedUserRoute, userRoute],
          },

          infoRoute,
          errorRoute,
        ],

        hydrateFallbackElement: hydrateFallback,
      },
    ]),
  };
}
